import { render, staticRenderFns } from "./datatableSolu.vue?vue&type=template&id=3a419526&"
import script from "./datatableSolu.vue?vue&type=script&lang=ts&"
export * from "./datatableSolu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports